/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_App_Including_PrefixInputs */

const en_marketing_app_including_prefix = /** @type {(inputs: Marketing_App_Including_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Including researchers & professors from`)
};

const es_marketing_app_including_prefix = /** @type {(inputs: Marketing_App_Including_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluyendo investigadores y profesores de`)
};

/**
* | output |
* | --- |
* | "Including researchers & professors from" |
*
* @param {Marketing_App_Including_PrefixInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const marketing_app_including_prefix = /** @type {((inputs?: Marketing_App_Including_PrefixInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_App_Including_PrefixInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_marketing_app_including_prefix(inputs)
	return en_marketing_app_including_prefix(inputs)
});